"use client";
import { createContext } from "react";
/**
 * Internal, exported only for usage in Framer
 */
export const SwitchLayoutGroupContext = createContext({});
//# sourceMappingURL=SwitchLayoutGroupContext.js.map